(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quntis-series"] && !Shopify.designMode) return;
  try {
    
  const qntSeriesI18n = {
    en: {
      eyebrow: 'Discover the Series',
      title: 'Find Your Light',
      intro: 'Start by exploring the four Quntis series, then find the one that fits your workspace.',
      comparisonEyebrow: 'Detailed comparison',
      comparisonTitle: 'Compare All Models',
      comparisonIntro: '',
      seriesFilter: 'Series',
      showDetails: 'Columns',
      detailCountOne: '1 selected',
      detailCountMany: '{count} selected',
      all: 'All',
      none: 'None',
      noResults: 'No products match the selected filters.',
      noRecommendedResults: 'No recommended products match these choices.',
      resultCountOne: '1 product shown',
      resultCountMany: '{count} products shown',
      shopMatchesExpand: 'Show all matching products',
      shopMatchesCollapse: 'Show fewer matching products',
      viewProduct: 'View product',
      columns: {
        product: 'Product',
        color: 'Color',
        shape: 'Shape',
        'monitor-type': 'Monitor type',
        'monitor-size': 'Fits monitor size',
        'monitor-thickness': 'Fits monitor thickness',
        backlight: 'Backlight',
        control: 'Control',
        'auto-dimming': 'Auto dimming',
        'stepless-dimming': 'Stepless dimming',
        'webcam-friendly': 'Webcam friendly',
        'multilight-control': 'Multi-light control',
        cri: 'CRI',
        'color-temperature': 'Color temperature',
        mounting: 'Mount type',
        'model-number': 'Model number'
      },
      series: {
        all: 'All',
        focus: 'Focus Series',
        glow: 'Glow Series',
        im: 'IM Series',
        studio: 'Studio Series'
      },
      cards: {
        focus: {
          label: 'Focus Series',
          short: 'Eye-care lighting for long focused hours.',
          detail: 'Eye-care monitor lights designed for extended work and study sessions. Delivers clean, glare-free front lighting, focusing light precisely on your work area, minimizing eye strain and maximizing deep focus.'
        },
        glow: {
          label: 'Glow Series',
          short: 'Eye-care front light with soft ambient backlight glow.',
          detail: 'Eye-care monitor lights with front lighting plus soft ambient backlight, balancing workspace illumination with gentle surrounding glow for work, reading, and relaxed evenings.'
        },
        im: {
          label: 'IM Series',
          short: 'Eye-care front light with immersive RGB backlight.',
          detail: 'Monitor lights with eye-care front lighting and RGB backlight, where IM stands for immersive and echoes I am, a statement of personal expression in light. Ideal for gaming, streaming, movies, music, and everyday desk setups.'
        },
        studio: {
          label: 'Studio Series',
          short: 'Even task lighting for creative workstations.',
          detail: 'Task lights for desks and workstations, from craft and illustration tables to model benches, piano corners and wide multi-monitor setups. Studio brings together clamp-on lamps and foldable wide-span bars that cast a broad, even wash of light while taking up minimal space.'
        }
      },
      options: {
        color: { all: 'All', black: 'Black', grey: 'Grey', white: 'White', pink: 'Pink' },
        shape: { all: 'All', straight: 'Straight', curved: 'Curved', foldable: 'Foldable', 'piano-light': 'Piano light' },
        monitorType: { all: 'All', 'curved-flat': 'Fits Curved / Flat Monitors', flat: 'Fits Flat Monitors', curved: 'Fits Curved Monitors', laptop: 'Fits Laptop Screens', 'non-monitor': 'Non-monitor light', 'all-monitor-types': 'All monitor types' },
        monitorSize: { all: 'All', '17-27': '43–69 cm (17–27 inch)', '17-32': '43–81 cm (17–32 inch)', '17-34': '43–86 cm (17–34 inch)', '32-49': '81–124 cm (32–49 inch)', 'all-sizes': 'All', 'laptop-11-17': '28–43 cm (Laptop 11–17 inch)', 'non-monitor': '/' },
        monitorThickness: { all: 'All', '0-3-7cm': '0.3–7 cm (0.12–2.76 inch)', '0-3-8cm': '0.3–8 cm (0.12–3.15 inch)', '0-3-8-5cm': '0.3–8.5 cm (0.12–3.35 inch)', '0-3-10cm': '0.3–10 cm (0.12–3.94 inch)', 'up-to-6cm': 'Up to 6 cm (2.36 inch)', 'up-to-9cm': 'Up to 9 cm (3.54 inch)', 'all-laptops': 'All laptops', 'not-specified': 'Not specified', 'not-applicable': '/' },
        backlight: { all: 'All', 'front-light-only': 'Front Light Only', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'All', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control', 'not-specified': 'Not specified' }
      },
      values: {
        Language: 'Language',
        Yes: 'Yes',
        No: 'No',
        'Supported via optional webcam accessory': 'Supported via optional webcam accessory',
        'Desk clamp': 'Clamps to desk edge',
        'Monitor clip': 'Mounts on monitor',
        'Table lamp': 'Sits on table',
        'Laptop screen clip': 'Clips onto laptop screen',
        'Clamps to desk edge': 'Clamps to desk edge',
        'Mounts on monitor': 'Mounts on monitor',
        'Sits on table': 'Sits on table',
        'Clips onto laptop screen': 'Clips onto laptop screen'
      }
    },
    zh: {
      eyebrow: 'Quntis 系列',
      title: 'Quntis 系列',
      intro: 'Quntis 是全场景桌面照明专家。产品体系覆盖提升视觉舒适度的前光、用于精细工作的任务照明，以及营造氛围的环境光，为工作、学习、游戏和创作提供沉稳、可靠的照明体验。',
      comparisonEyebrow: '产品对比',
      comparisonTitle: 'Quntis 灯条对比',
      comparisonIntro: '我们将 Quntis 灯条划分为不同系列，每个系列对应不同的照明需求和桌面场景。下面是快速对比。',
      seriesFilter: '系列筛选',
      showDetails: '显示参数',
      all: '全部',
      none: '不显示',
      noResults: '没有符合当前筛选条件的产品。',
      columns: {
        product: '产品',
        color: '颜色',
        shape: '形状',
        'monitor-type': '适配屏幕类型',
        'monitor-size': '适配屏幕尺寸',
        backlight: '背光',
        control: '控制方式',
        'auto-dimming': '自动调光',
        'stepless-dimming': '无级调光',
        'webcam-friendly': '摄像头友好',
        'multilight-control': '多灯联控',
        cri: '显色指数',
        'color-temperature': '色温',
        mounting: '安装方式',
        'model-number': '型号'
      },
      series: { all: '全部', focus: 'Focus 系列', glow: 'Glow 系列', im: 'IM 系列', studio: 'Studio 系列' },
      cards: {
        focus: { label: 'Focus 系列', short: '适合长时间专注使用的护眼屏幕灯。', detail: '面向长时间工作和学习场景的护眼屏幕灯。提供清晰、低眩光的前光，将光线更准确地投向工作区域，帮助减少用眼负担并提升专注感。' },
        glow: { label: 'Glow 系列', short: '前光护眼，同时带来柔和背光氛围。', detail: '带前光与柔和背光的护眼屏幕灯，在照亮桌面的同时提供轻柔的环境光，适合工作、阅读和放松的夜间桌面场景。' },
        im: { label: 'IM 系列', short: '护眼前光与沉浸式 RGB 背光结合。', detail: '结合护眼前光与 RGB 背光的屏幕灯。IM 代表 immersive，也呼应 I am，强调用光表达个人风格，适合游戏、直播、影音和日常桌面布置。' },
        studio: { label: 'Studio 系列', short: '为创作、阅读和宽桌面准备的任务照明。', detail: '面向桌面和工作台的任务照明，覆盖手工、插画、模型、钢琴角落和多屏宽桌面。Studio 包含夹灯和折叠宽幅灯条，在占用较少空间的同时提供更宽、更均匀的光。' }
      },
      options: {
        color: { all: '全部', black: '黑色', grey: '灰色', white: '白色', pink: '粉色' },
        shape: { all: '全部', straight: '直灯条', curved: '弧形灯条', foldable: '折叠式', 'piano-light': '钢琴灯' },
        monitorType: { all: '全部', 'curved-flat': '适配曲面 / 平面显示器', flat: '适配平面显示器', curved: '适配曲面显示器' },
        monitorSize: { all: '全部', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': '非屏幕灯', desk: '桌面 / 工作台' },
        backlight: { all: '全部', 'front-light-only': '仅前光', backlight: '背光', 'rgb-backlight': 'RGB 背光' },
        control: { all: '全部', 'touch-control': '触控', 'remote-control': '遥控', 'touch-remote': '触控与遥控' }
      },
      values: { Language: '语言', Yes: '是', No: '否', 'Supported via optional webcam accessory': '支持可选摄像头配件', 'Desk clamp': '桌夹', 'Monitor clip': '显示器夹', 'Table lamp': '台灯' }
    },
    de: {
      eyebrow: 'Quntis Serien',
      title: 'Quntis Serien',
      intro: 'Quntis ist Spezialist für Beleuchtung am Schreibtisch. Das Produktsystem umfasst Frontlicht für Sehkomfort, Arbeitslicht für Präzision und Umgebungslicht für Atmosphäre. Quntis liefert ruhiges, zuverlässiges Licht für Arbeit, Studium, Gaming und kreative Setups.',
      comparisonEyebrow: 'Produktvergleich',
      comparisonTitle: 'Quntis Light-Bar-Vergleich',
      comparisonIntro: 'Quntis Light Bars sind in klare Serien gegliedert, die unterschiedliche Beleuchtungsbedürfnisse und Schreibtischszenarien abdecken. Hier finden Sie einen schnellen Überblick.',
      seriesFilter: 'Serienfilter',
      showDetails: 'Details anzeigen',
      all: 'Alle',
      none: 'Keine',
      noResults: 'Keine Produkte entsprechen den gewählten Filtern.',
      columns: { product: 'Produkt', color: 'Farbe', shape: 'Form', 'monitor-type': 'Monitortyp', 'monitor-size': 'Passende Monitorgröße', backlight: 'Backlight', control: 'Steuerung', 'auto-dimming': 'Auto Dimming', 'stepless-dimming': 'Stufenloses Dimmen', 'webcam-friendly': 'Webcam-freundlich', 'multilight-control': 'Multi-Light Control', cri: 'CRI', 'color-temperature': 'Farbtemperatur', mounting: 'Montage', 'model-number': 'Modellnummer' },
      series: { all: 'Alle', focus: 'Focus Serie', glow: 'Glow Serie', im: 'IM Serie', studio: 'Studio Serie' },
      cards: {
        focus: { label: 'Focus Serie', short: 'Augenschonendes Licht für lange konzentrierte Stunden.', detail: 'Eye-care Monitorleuchten für längere Arbeits- und Lernphasen. Sauberes, blendarmes Frontlicht richtet das Licht präzise auf den Arbeitsbereich und unterstützt konzentriertes Arbeiten.' },
        glow: { label: 'Glow Serie', short: 'Frontlicht mit weichem Ambient-Backlight.', detail: 'Eye-care Monitorleuchten mit Frontlicht und sanftem Backlight, die Arbeitsflächenbeleuchtung mit einer ruhigen Umgebungswirkung verbinden.' },
        im: { label: 'IM Serie', short: 'Frontlicht mit immersivem RGB-Backlight.', detail: 'Monitorleuchten mit eye-care Frontlicht und RGB-Backlight. IM steht für immersive und erinnert an I am, ein Ausdruck persönlicher Lichtgestaltung.' },
        studio: { label: 'Studio Serie', short: 'Arbeitslicht für kreative Workstations.', detail: 'Arbeitsleuchten für Schreibtische und Workstations, von Bastel- und Zeichentischen bis zu Modellbau, Klavierbereichen und breiten Multi-Monitor-Setups.' }
      },
      options: {
        color: { all: 'Alle', black: 'Schwarz', grey: 'Grau', white: 'Weiß', pink: 'Rosa' },
        shape: { all: 'Alle', straight: 'Gerade', curved: 'Gebogen', foldable: 'Faltbar', 'piano-light': 'Klavierleuchte' },
        monitorType: { all: 'Alle', 'curved-flat': 'Für gebogene / flache Monitore', flat: 'Für flache Monitore', curved: 'Für gebogene Monitore' },
        monitorSize: { all: 'Alle', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'Keine Monitorleuchte', desk: 'Schreibtisch / Workstation' },
        backlight: { all: 'Alle', 'front-light-only': 'Nur Frontlicht', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'Alle', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control' }
      },
      values: { Language: 'Sprache', Yes: 'Ja', No: 'Nein', 'Supported via optional webcam accessory': 'Mit optionalem Webcam-Zubehör unterstützt', 'Desk clamp': 'Tischklemme', 'Monitor clip': 'Monitorclip', 'Table lamp': 'Tischleuchte' }
    },
    es: {
      eyebrow: 'Series Quntis',
      title: 'Series Quntis',
      intro: 'Quntis es especialista en iluminación de escritorio para distintos escenarios. Su sistema cubre luz frontal para confort visual, luz de trabajo para precisión y luz ambiental para crear atmósfera.',
      comparisonEyebrow: 'Comparación de productos',
      comparisonTitle: 'Comparación de barras de luz Quntis',
      comparisonIntro: 'Hemos organizado las barras de luz Quntis en series claras, cada una pensada para distintas necesidades de iluminación y escenarios de escritorio.',
      seriesFilter: 'Filtro de series',
      showDetails: 'Mostrar detalles',
      all: 'Todo',
      none: 'Ninguno',
      noResults: 'No hay productos que coincidan con los filtros seleccionados.',
      columns: { product: 'Producto', color: 'Color', shape: 'Forma', 'monitor-type': 'Tipo de monitor', 'monitor-size': 'Tamaño de monitor compatible', backlight: 'Luz trasera', control: 'Control', 'auto-dimming': 'Atenuación automática', 'stepless-dimming': 'Atenuación continua', 'webcam-friendly': 'Compatible con webcam', 'multilight-control': 'Control multi-luz', cri: 'CRI', 'color-temperature': 'Temperatura de color', mounting: 'Instalación', 'model-number': 'Número de modelo' },
      series: { all: 'Todo', focus: 'Serie Focus', glow: 'Serie Glow', im: 'Serie IM', studio: 'Serie Studio' },
      cards: {
        focus: { label: 'Serie Focus', short: 'Iluminación eye-care para largas horas de concentración.', detail: 'Luces para monitor diseñadas para trabajo y estudio prolongados, con luz frontal limpia y antirreflejos que dirige la iluminación al área de trabajo.' },
        glow: { label: 'Serie Glow', short: 'Luz frontal eye-care con suave luz trasera ambiental.', detail: 'Luces para monitor con luz frontal y backlight suave, equilibrando la iluminación del escritorio con una atmósfera más cómoda.' },
        im: { label: 'Serie IM', short: 'Luz frontal eye-care con RGB backlight inmersivo.', detail: 'Luces para monitor con luz frontal y RGB backlight. IM significa immersive y evoca I am, una expresión personal a través de la luz.' },
        studio: { label: 'Serie Studio', short: 'Luz de trabajo para estaciones creativas.', detail: 'Luces de tarea para escritorios y puestos de trabajo, desde manualidades e ilustración hasta piano, maquetas y setups amplios con varios monitores.' }
      },
      options: {
        color: { all: 'Todo', black: 'Negro', grey: 'Gris', white: 'Blanco', pink: 'Rosa' },
        shape: { all: 'Todo', straight: 'Recta', curved: 'Curva', foldable: 'Plegable', 'piano-light': 'Luz para piano' },
        monitorType: { all: 'Todo', 'curved-flat': 'Para monitores curvos / planos', flat: 'Para monitores planos', curved: 'Para monitores curvos' },
        monitorSize: { all: 'Todo', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'No es luz de monitor', desk: 'Escritorio / estación de trabajo' },
        backlight: { all: 'Todo', 'front-light-only': 'Solo luz frontal', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'Todo', 'touch-control': 'Control táctil', 'remote-control': 'Control remoto', 'touch-remote': 'Control táctil y remoto' }
      },
      values: { Language: 'Idioma', Yes: 'Sí', No: 'No', 'Supported via optional webcam accessory': 'Compatible con accesorio opcional para webcam', 'Desk clamp': 'Abrazadera de escritorio', 'Monitor clip': 'Clip para monitor', 'Table lamp': 'Lámpara de mesa' }
    },
    fr: {
      eyebrow: 'Séries Quntis',
      title: 'Séries Quntis',
      intro: 'Quntis est spécialiste de l’éclairage de bureau multi-scénarios. Notre système couvre la lumière frontale pour le confort visuel, l’éclairage de tâche pour la précision et la lumière d’ambiance.',
      comparisonEyebrow: 'Comparaison produits',
      comparisonTitle: 'Comparatif des light bars Quntis',
      comparisonIntro: 'Les light bars Quntis sont classées par séries, chacune adaptée à des besoins d’éclairage et à des scénarios de bureau spécifiques.',
      seriesFilter: 'Filtre de série',
      showDetails: 'Afficher les détails',
      all: 'Tout',
      none: 'Aucun',
      noResults: 'Aucun produit ne correspond aux filtres sélectionnés.',
      columns: { product: 'Produit', color: 'Couleur', shape: 'Forme', 'monitor-type': 'Type d’écran', 'monitor-size': 'Taille d’écran compatible', backlight: 'Backlight', control: 'Commande', 'auto-dimming': 'Auto Dimming', 'stepless-dimming': 'Variation continue', 'webcam-friendly': 'Compatible webcam', 'multilight-control': 'Multi-Light Control', cri: 'CRI', 'color-temperature': 'Température de couleur', mounting: 'Installation', 'model-number': 'Numéro de modèle' },
      series: { all: 'Tout', focus: 'Série Focus', glow: 'Série Glow', im: 'Série IM', studio: 'Série Studio' },
      cards: {
        focus: { label: 'Série Focus', short: 'Éclairage eye-care pour de longues heures de concentration.', detail: 'Light bars pour écran conçues pour de longues sessions de travail et d’étude, avec une lumière frontale nette et sans éblouissement dirigée vers la zone de travail.' },
        glow: { label: 'Série Glow', short: 'Lumière frontale eye-care avec backlight doux.', detail: 'Light bars avec lumière frontale et backlight doux, équilibrant l’éclairage du bureau avec une ambiance plus calme.' },
        im: { label: 'Série IM', short: 'Lumière frontale eye-care avec RGB backlight immersif.', detail: 'Light bars avec lumière frontale et RGB backlight. IM signifie immersive et évoque I am, une expression personnelle par la lumière.' },
        studio: { label: 'Série Studio', short: 'Éclairage de tâche pour postes créatifs.', detail: 'Lampes de tâche pour bureaux et postes de travail, de l’illustration aux maquettes, coins piano et grands setups multi-écrans.' }
      },
      options: {
        color: { all: 'Tout', black: 'Noir', grey: 'Gris', white: 'Blanc', pink: 'Rose' },
        shape: { all: 'Tout', straight: 'Droite', curved: 'Courbée', foldable: 'Pliable', 'piano-light': 'Lampe de piano' },
        monitorType: { all: 'Tout', 'curved-flat': 'Pour écrans courbés / plats', flat: 'Pour écrans plats', curved: 'Pour écrans courbés' },
        monitorSize: { all: 'Tout', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'Pas une light bar écran', desk: 'Bureau / poste de travail' },
        backlight: { all: 'Tout', 'front-light-only': 'Lumière frontale uniquement', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'Tout', 'touch-control': 'Commande tactile', 'remote-control': 'Télécommande', 'touch-remote': 'Commande tactile et télécommande' }
      },
      values: { Language: 'Langue', Yes: 'Oui', No: 'Non', 'Supported via optional webcam accessory': 'Compatible avec accessoire webcam optionnel', 'Desk clamp': 'Pince de bureau', 'Monitor clip': 'Clip écran', 'Table lamp': 'Lampe de table' }
    },
    it: {
      eyebrow: 'Serie Quntis',
      title: 'Serie Quntis',
      intro: 'Quntis è specialista nell’illuminazione da scrivania per diversi scenari. Il sistema copre luce frontale per il comfort visivo, luce da lavoro per precisione e luce ambientale.',
      comparisonEyebrow: 'Confronto prodotti',
      comparisonTitle: 'Confronto light bar Quntis',
      comparisonIntro: 'Le light bar Quntis sono organizzate in serie distinte, ciascuna pensata per esigenze di illuminazione e scenari di scrivania diversi.',
      seriesFilter: 'Filtro serie',
      showDetails: 'Mostra dettagli',
      all: 'Tutti',
      none: 'Nessuno',
      noResults: 'Nessun prodotto corrisponde ai filtri selezionati.',
      columns: { product: 'Prodotto', color: 'Colore', shape: 'Forma', 'monitor-type': 'Tipo monitor', 'monitor-size': 'Dimensione monitor compatibile', backlight: 'Backlight', control: 'Controllo', 'auto-dimming': 'Auto Dimming', 'stepless-dimming': 'Dimmerazione continua', 'webcam-friendly': 'Compatibile webcam', 'multilight-control': 'Controllo multi-luce', cri: 'CRI', 'color-temperature': 'Temperatura colore', mounting: 'Montaggio', 'model-number': 'Numero modello' },
      series: { all: 'Tutti', focus: 'Serie Focus', glow: 'Serie Glow', im: 'Serie IM', studio: 'Serie Studio' },
      cards: {
        focus: { label: 'Serie Focus', short: 'Illuminazione eye-care per lunghe ore di concentrazione.', detail: 'Light bar per monitor progettate per lavoro e studio prolungati, con luce frontale pulita e anti-riflesso diretta sull’area di lavoro.' },
        glow: { label: 'Serie Glow', short: 'Luce frontale eye-care con backlight morbido.', detail: 'Light bar con luce frontale e backlight morbido, per bilanciare illuminazione del piano e atmosfera circostante.' },
        im: { label: 'Serie IM', short: 'Luce frontale eye-care con RGB backlight immersivo.', detail: 'Light bar con luce frontale e RGB backlight. IM significa immersive e richiama I am, una dichiarazione personale attraverso la luce.' },
        studio: { label: 'Serie Studio', short: 'Luce da lavoro per postazioni creative.', detail: 'Lampade da lavoro per scrivanie e workstation, da tavoli per illustrazione e modellismo ad angoli pianoforte e setup ampi multi-monitor.' }
      },
      options: {
        color: { all: 'Tutti', black: 'Nero', grey: 'Grigio', white: 'Bianco', pink: 'Rosa' },
        shape: { all: 'Tutti', straight: 'Dritta', curved: 'Curva', foldable: 'Pieghevole', 'piano-light': 'Luce per pianoforte' },
        monitorType: { all: 'Tutti', 'curved-flat': 'Per monitor curvi / piatti', flat: 'Per monitor piatti', curved: 'Per monitor curvi' },
        monitorSize: { all: 'Tutti', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'Non per monitor', desk: 'Scrivania / workstation' },
        backlight: { all: 'Tutti', 'front-light-only': 'Solo luce frontale', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'Tutti', 'touch-control': 'Controllo touch', 'remote-control': 'Telecomando', 'touch-remote': 'Controllo touch e telecomando' }
      },
      values: { Language: 'Lingua', Yes: 'Sì', No: 'No', 'Supported via optional webcam accessory': 'Supportato con accessorio webcam opzionale', 'Desk clamp': 'Morsetto da scrivania', 'Monitor clip': 'Clip monitor', 'Table lamp': 'Lampada da tavolo' }
    },
    pt: {
      eyebrow: 'Séries Quntis',
      title: 'Séries Quntis',
      intro: 'A Quntis é especialista em iluminação de mesa para diferentes cenários. Nosso sistema cobre luz frontal para conforto visual, luz de tarefa para precisão e luz ambiente.',
      comparisonEyebrow: 'Comparação de produtos',
      comparisonTitle: 'Comparação de light bars Quntis',
      comparisonIntro: 'Organizamos as light bars Quntis em séries distintas, cada uma voltada a diferentes necessidades de iluminação e cenários de mesa.',
      seriesFilter: 'Filtro de série',
      showDetails: 'Mostrar detalhes',
      all: 'Todos',
      none: 'Nenhum',
      noResults: 'Nenhum produto corresponde aos filtros selecionados.',
      columns: { product: 'Produto', color: 'Cor', shape: 'Formato', 'monitor-type': 'Tipo de monitor', 'monitor-size': 'Tamanho de monitor compatível', backlight: 'Backlight', control: 'Controle', 'auto-dimming': 'Auto Dimming', 'stepless-dimming': 'Dimerização contínua', 'webcam-friendly': 'Compatível com webcam', 'multilight-control': 'Controle multi-luz', cri: 'CRI', 'color-temperature': 'Temperatura de cor', mounting: 'Instalação', 'model-number': 'Número do modelo' },
      series: { all: 'Todos', focus: 'Série Focus', glow: 'Série Glow', im: 'Série IM', studio: 'Série Studio' },
      cards: {
        focus: { label: 'Série Focus', short: 'Iluminação eye-care para longas horas de foco.', detail: 'Light bars para monitor projetadas para trabalho e estudo prolongados, com luz frontal limpa e sem reflexos direcionada à área de trabalho.' },
        glow: { label: 'Série Glow', short: 'Luz frontal eye-care com backlight suave.', detail: 'Light bars com luz frontal e backlight suave, equilibrando a iluminação da mesa com uma atmosfera mais confortável.' },
        im: { label: 'Série IM', short: 'Luz frontal eye-care com RGB backlight imersivo.', detail: 'Light bars com luz frontal e RGB backlight. IM significa immersive e lembra I am, uma expressão pessoal em luz.' },
        studio: { label: 'Série Studio', short: 'Luz de tarefa para estações criativas.', detail: 'Luzes de tarefa para mesas e workstations, de artesanato e ilustração a bancadas, piano e setups amplos com vários monitores.' }
      },
      options: {
        color: { all: 'Todos', black: 'Preto', grey: 'Cinza', white: 'Branco', pink: 'Rosa' },
        shape: { all: 'Todos', straight: 'Reta', curved: 'Curva', foldable: 'Dobrável', 'piano-light': 'Luz para piano' },
        monitorType: { all: 'Todos', 'curved-flat': 'Para monitores curvos / planos', flat: 'Para monitores planos', curved: 'Para monitores curvos' },
        monitorSize: { all: 'Todos', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'Não é luz de monitor', desk: 'Mesa / estação de trabalho' },
        backlight: { all: 'Todos', 'front-light-only': 'Apenas luz frontal', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'Todos', 'touch-control': 'Controle touch', 'remote-control': 'Controle remoto', 'touch-remote': 'Controle touch e remoto' }
      },
      values: { Language: 'Idioma', Yes: 'Sim', No: 'Não', 'Supported via optional webcam accessory': 'Compatível com acessório opcional para webcam', 'Desk clamp': 'Presilha de mesa', 'Monitor clip': 'Clipe para monitor', 'Table lamp': 'Luminária de mesa' }
    },
    ja: {
      eyebrow: 'Quntis シリーズ',
      title: 'Quntis シリーズ',
      intro: 'Quntis は、さまざまなデスク環境に対応する照明ブランドです。視覚的な快適さを支えるフロントライト、精密作業向けのタスクライト、空間の雰囲気を整えるアンビエントライトを展開しています。',
      comparisonEyebrow: '製品比較',
      comparisonTitle: 'Quntis ライトバー比較',
      comparisonIntro: 'Quntis のライトバーは、照明ニーズやデスク環境に合わせて複数のシリーズに整理されています。以下で概要を確認できます。',
      seriesFilter: 'シリーズフィルター',
      showDetails: '詳細を表示',
      all: 'すべて',
      none: 'なし',
      noResults: '選択した条件に一致する製品がありません。',
      columns: { product: '製品', color: 'カラー', shape: '形状', 'monitor-type': '対応モニタータイプ', 'monitor-size': '対応モニターサイズ', backlight: 'バックライト', control: '操作方法', 'auto-dimming': '自動調光', 'stepless-dimming': '無段階調光', 'webcam-friendly': 'Webカメラ対応', 'multilight-control': 'マルチライト制御', cri: 'CRI', 'color-temperature': '色温度', mounting: '取り付け', 'model-number': '型番' },
      series: { all: 'すべて', focus: 'Focus シリーズ', glow: 'Glow シリーズ', im: 'IM シリーズ', studio: 'Studio シリーズ' },
      cards: {
        focus: { label: 'Focus シリーズ', short: '長時間の集中に適した eye-care ライト。', detail: '長時間の仕事や学習に向けたモニターライト。クリアでグレアを抑えたフロントライトが作業エリアを照らし、集中しやすい環境を整えます。' },
        glow: { label: 'Glow シリーズ', short: 'フロントライトとやわらかなバックライト。', detail: 'フロントライトにソフトなバックライトを組み合わせたモニターライト。作業、読書、夜のデスク時間に落ち着いた光を加えます。' },
        im: { label: 'IM シリーズ', short: 'フロントライトと没入感のある RGB バックライト。', detail: 'eye-care フロントライトと RGB バックライトを備えたモニターライト。IM は immersive を表し、I am とも響き合う、光による自己表現です。' },
        studio: { label: 'Studio シリーズ', short: 'クリエイティブな作業環境向けのタスクライト。', detail: 'デスクやワークステーション向けのタスクライト。クラフト、イラスト、模型、ピアノ、広いマルチモニター環境まで幅広く対応します。' }
      },
      options: {
        color: { all: 'すべて', black: 'ブラック', grey: 'グレー', white: 'ホワイト', pink: 'ピンク' },
        shape: { all: 'すべて', straight: 'ストレート', curved: 'カーブ', foldable: '折りたたみ式', 'piano-light': 'ピアノライト' },
        monitorType: { all: 'すべて', 'curved-flat': '曲面 / 平面モニター対応', flat: '平面モニター対応', curved: '曲面モニター対応' },
        monitorSize: { all: 'すべて', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'モニターライト以外', desk: 'デスク / ワークステーション' },
        backlight: { all: 'すべて', 'front-light-only': 'フロントライトのみ', backlight: 'バックライト', 'rgb-backlight': 'RGB バックライト' },
        control: { all: 'すべて', 'touch-control': 'タッチ操作', 'remote-control': 'リモコン操作', 'touch-remote': 'タッチ操作とリモコン操作' }
      },
      values: { Language: '言語', Yes: 'はい', No: 'いいえ', 'Supported via optional webcam accessory': '別売りWebカメラアクセサリー対応', 'Desk clamp': 'デスククランプ', 'Monitor clip': 'モニタークリップ', 'Table lamp': 'テーブルランプ' }
    },
    ar: {
      eyebrow: 'سلاسل Quntis',
      title: 'سلاسل Quntis',
      intro: 'Quntis متخصصة في إضاءة المكاتب لمختلف السيناريوهات. يغطي نظام المنتجات الإضاءة الأمامية لراحة الرؤية، وإضاءة المهام للدقة، والإضاءة المحيطية للأجواء.',
      comparisonEyebrow: 'مقارنة المنتجات',
      comparisonTitle: 'مقارنة مصابيح Quntis',
      comparisonIntro: 'تم تنظيم مصابيح Quntis في سلاسل واضحة، كل منها مخصص لاحتياجات إضاءة وسيناريوهات مكتب مختلفة.',
      seriesFilter: 'تصفية السلسلة',
      showDetails: 'عرض التفاصيل',
      all: 'الكل',
      none: 'بدون',
      noResults: 'لا توجد منتجات تطابق عوامل التصفية المحددة.',
      columns: { product: 'المنتج', color: 'اللون', shape: 'الشكل', 'monitor-type': 'نوع الشاشة', 'monitor-size': 'حجم الشاشة المناسب', backlight: 'الإضاءة الخلفية', control: 'التحكم', 'auto-dimming': 'التعتيم التلقائي', 'stepless-dimming': 'تعتيم متدرج بسلاسة', 'webcam-friendly': 'مناسب للكاميرا', 'multilight-control': 'تحكم متعدد المصابيح', cri: 'CRI', 'color-temperature': 'درجة حرارة اللون', mounting: 'طريقة التركيب', 'model-number': 'رقم الطراز' },
      series: { all: 'الكل', focus: 'سلسلة Focus', glow: 'سلسلة Glow', im: 'سلسلة IM', studio: 'سلسلة Studio' },
      cards: {
        focus: { label: 'سلسلة Focus', short: 'إضاءة مريحة للعين لساعات التركيز الطويلة.', detail: 'مصابيح شاشة مصممة لجلسات العمل والدراسة الطويلة، مع إضاءة أمامية واضحة ومريحة توجه الضوء إلى منطقة العمل.' },
        glow: { label: 'سلسلة Glow', short: 'إضاءة أمامية مريحة مع إضاءة خلفية ناعمة.', detail: 'مصابيح شاشة تجمع بين الإضاءة الأمامية والإضاءة الخلفية الهادئة، لتوازن إضاءة المكتب مع أجواء محيطة ناعمة.' },
        im: { label: 'سلسلة IM', short: 'إضاءة أمامية مع RGB Backlight غامر.', detail: 'مصابيح شاشة بإضاءة أمامية مريحة وRGB Backlight. يرمز IM إلى immersive ويعكس I am كتعبير شخصي بالضوء.' },
        studio: { label: 'سلسلة Studio', short: 'إضاءة مهام لمحطات العمل الإبداعية.', detail: 'إضاءة مهام للمكاتب ومحطات العمل، من الطاولات الإبداعية وزوايا البيانو إلى إعدادات الشاشات المتعددة الواسعة.' }
      },
      options: {
        color: { all: 'الكل', black: 'أسود', grey: 'رمادي', white: 'أبيض', pink: 'وردي' },
        shape: { all: 'الكل', straight: 'مستقيم', curved: 'منحني', foldable: 'قابل للطي', 'piano-light': 'مصباح بيانو' },
        monitorType: { all: 'الكل', 'curved-flat': 'للشاشات المنحنية / المسطحة', flat: 'للشاشات المسطحة', curved: 'للشاشات المنحنية' },
        monitorSize: { all: 'الكل', '17-21': '17"–21"', '17-34': '17"–34"', '17-49': '17"–49"', '21-49': '21"–49"', '24-49': '24"–49"', 'non-monitor': 'ليس مصباح شاشة', desk: 'مكتب / محطة عمل' },
        backlight: { all: 'الكل', 'front-light-only': 'إضاءة أمامية فقط', backlight: 'إضاءة خلفية', 'rgb-backlight': 'RGB Backlight' },
        control: { all: 'الكل', 'touch-control': 'تحكم باللمس', 'remote-control': 'تحكم عن بعد', 'touch-remote': 'تحكم باللمس وعن بعد' }
      },
      values: { Language: 'اللغة', Yes: 'نعم', No: 'لا', 'Supported via optional webcam accessory': 'مدعوم عبر ملحق كاميرا اختياري', 'Desk clamp': 'مشبك مكتب', 'Monitor clip': 'مشبك شاشة', 'Table lamp': 'مصباح طاولة' }
    }
  };

  qntSeriesI18n.nl = {
    ...qntSeriesI18n.en,
    eyebrow: 'Quntis series',
    title: 'Quntis series',
    intro: 'Quntis is gespecialiseerd in bureauverlichting voor verschillende scenario’s. Het productsysteem omvat front light voor visueel comfort, taakverlichting voor precisie en ambient light voor sfeer.',
    comparisonEyebrow: 'Productvergelijking',
    comparisonTitle: 'Quntis light bar vergelijking',
    comparisonIntro: 'Quntis light bars zijn ingedeeld in duidelijke series, elk afgestemd op andere lichtbehoeften en bureau-scenario’s.',
    seriesFilter: 'Seriefilter',
    showDetails: 'Details tonen',
    all: 'Alles',
    none: 'Geen',
    noResults: 'Geen producten gevonden voor de geselecteerde filters.',
    columns: { ...qntSeriesI18n.en.columns, product: 'Product', color: 'Kleur', shape: 'Vorm', 'monitor-type': 'Monitortype', 'monitor-size': 'Geschikte monitorgrootte', backlight: 'Backlight', control: 'Bediening', mounting: 'Montage', 'model-number': 'Modelnummer' },
    series: { all: 'Alles', focus: 'Focus serie', glow: 'Glow serie', im: 'IM serie', studio: 'Studio serie' },
    options: {
      color: { all: 'Alles', black: 'Zwart', grey: 'Grijs', white: 'Wit', pink: 'Roze' },
      shape: { all: 'Alles', straight: 'Recht', curved: 'Gebogen', foldable: 'Opvouwbaar', 'piano-light': 'Pianolamp' },
      monitorType: { all: 'Alles', 'curved-flat': 'Voor gebogen / platte monitoren', flat: 'Voor platte monitoren', curved: 'Voor gebogen monitoren' },
      monitorSize: qntSeriesI18n.en.options.monitorSize,
      backlight: { all: 'Alles', 'front-light-only': 'Alleen front light', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
      control: { all: 'Alles', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control' }
    },
    values: { ...qntSeriesI18n.en.values, Yes: 'Ja', No: 'Nee', 'Desk clamp': 'Bureauklem', 'Monitor clip': 'Monitorclip', 'Table lamp': 'Tafellamp' }
  };
  qntSeriesI18n.sv = {
    ...qntSeriesI18n.en,
    eyebrow: 'Quntis serier',
    title: 'Quntis serier',
    intro: 'Quntis är specialist på skrivbordsbelysning för olika scenarier. Produktsystemet omfattar front light för visuell komfort, arbetsljus för precision och ambient light för atmosfär.',
    comparisonEyebrow: 'Produktjämförelse',
    comparisonTitle: 'Quntis light bar jämförelse',
    comparisonIntro: 'Quntis light bars är indelade i tydliga serier, anpassade för olika ljusbehov och skrivbordsscenarier.',
    all: 'Alla',
    none: 'Inga',
    showDetails: 'Visa detaljer',
    noResults: 'Inga produkter matchar de valda filtren.',
    columns: { ...qntSeriesI18n.en.columns, color: 'Färg', shape: 'Form', 'monitor-type': 'Monitortyp', 'monitor-size': 'Passar monitorstorlek', control: 'Kontroll', mounting: 'Montering', 'model-number': 'Modellnummer' },
    series: { all: 'Alla', focus: 'Focus serie', glow: 'Glow serie', im: 'IM serie', studio: 'Studio serie' },
    options: {
      color: { all: 'Alla', black: 'Svart', grey: 'Grå', white: 'Vit', pink: 'Rosa' },
      shape: { all: 'Alla', straight: 'Rak', curved: 'Böjd', foldable: 'Vikbar', 'piano-light': 'Pianolampa' },
      monitorType: { all: 'Alla', 'curved-flat': 'För böjda / platta monitorer', flat: 'För platta monitorer', curved: 'För böjda monitorer' },
      monitorSize: qntSeriesI18n.en.options.monitorSize,
      backlight: { all: 'Alla', 'front-light-only': 'Endast front light', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
      control: { all: 'Alla', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control' }
    },
    values: { ...qntSeriesI18n.en.values, Yes: 'Ja', No: 'Nej', 'Desk clamp': 'Bordsklämma', 'Monitor clip': 'Monitorklämma', 'Table lamp': 'Bordslampa' }
  };
  qntSeriesI18n.pl = {
    ...qntSeriesI18n.en,
    eyebrow: 'Serie Quntis',
    title: 'Serie Quntis',
    intro: 'Quntis specjalizuje się w oświetleniu biurkowym do różnych scenariuszy. System produktów obejmuje front light dla komfortu widzenia, oświetlenie zadaniowe i światło ambientowe.',
    comparisonEyebrow: 'Porównanie produktów',
    comparisonTitle: 'Porównanie Quntis light bar',
    comparisonIntro: 'Light bary Quntis są podzielone na serie, z których każda odpowiada innym potrzebom oświetleniowym i scenariuszom pracy przy biurku.',
    all: 'Wszystkie',
    none: 'Brak',
    showDetails: 'Pokaż szczegóły',
    noResults: 'Brak produktów pasujących do wybranych filtrów.',
    columns: { ...qntSeriesI18n.en.columns, color: 'Kolor', shape: 'Kształt', 'monitor-type': 'Typ monitora', 'monitor-size': 'Pasujący rozmiar monitora', control: 'Sterowanie', mounting: 'Montaż', 'model-number': 'Numer modelu' },
    series: { all: 'Wszystkie', focus: 'Seria Focus', glow: 'Seria Glow', im: 'Seria IM', studio: 'Seria Studio' },
    options: {
      color: { all: 'Wszystkie', black: 'Czarny', grey: 'Szary', white: 'Biały', pink: 'Różowy' },
      shape: { all: 'Wszystkie', straight: 'Prosty', curved: 'Zakrzywiony', foldable: 'Składany', 'piano-light': 'Lampa do pianina' },
      monitorType: { all: 'Wszystkie', 'curved-flat': 'Do monitorów zakrzywionych / płaskich', flat: 'Do monitorów płaskich', curved: 'Do monitorów zakrzywionych' },
      monitorSize: qntSeriesI18n.en.options.monitorSize,
      backlight: { all: 'Wszystkie', 'front-light-only': 'Tylko front light', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
      control: { all: 'Wszystkie', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control' }
    },
    values: { ...qntSeriesI18n.en.values, Yes: 'Tak', No: 'Nie', 'Desk clamp': 'Zacisk biurkowy', 'Monitor clip': 'Klips do monitora', 'Table lamp': 'Lampa stołowa' }
  };
  qntSeriesI18n.tr = {
    ...qntSeriesI18n.en,
    eyebrow: 'Quntis serileri',
    title: 'Quntis serileri',
    intro: 'Quntis, farklı masa aydınlatma senaryolarına odaklanan bir uzmandır. Ürün sistemi görsel konfor için front light, hassas işler için görev ışığı ve atmosfer için ambient light kapsar.',
    comparisonEyebrow: 'Ürün karşılaştırması',
    comparisonTitle: 'Quntis light bar karşılaştırması',
    comparisonIntro: 'Quntis light bar ürünleri, farklı aydınlatma ihtiyaçlarına ve masa senaryolarına göre net serilere ayrılmıştır.',
    all: 'Tümü',
    none: 'Hiçbiri',
    showDetails: 'Detayları göster',
    noResults: 'Seçilen filtrelerle eşleşen ürün yok.',
    columns: { ...qntSeriesI18n.en.columns, color: 'Renk', shape: 'Şekil', 'monitor-type': 'Monitör tipi', 'monitor-size': 'Uyumlu monitör boyutu', control: 'Kontrol', mounting: 'Montaj', 'model-number': 'Model numarası' },
    series: { all: 'Tümü', focus: 'Focus serisi', glow: 'Glow serisi', im: 'IM serisi', studio: 'Studio serisi' },
    options: {
      color: { all: 'Tümü', black: 'Siyah', grey: 'Gri', white: 'Beyaz', pink: 'Pembe' },
      shape: { all: 'Tümü', straight: 'Düz', curved: 'Kavisli', foldable: 'Katlanabilir', 'piano-light': 'Piyano ışığı' },
      monitorType: { all: 'Tümü', 'curved-flat': 'Kavisli / düz monitörlere uygun', flat: 'Düz monitörlere uygun', curved: 'Kavisli monitörlere uygun' },
      monitorSize: qntSeriesI18n.en.options.monitorSize,
      backlight: { all: 'Tümü', 'front-light-only': 'Yalnızca front light', backlight: 'Backlight', 'rgb-backlight': 'RGB Backlight' },
      control: { all: 'Tümü', 'touch-control': 'Touch Control', 'remote-control': 'Remote Control', 'touch-remote': 'Touch Control & Remote Control' }
    },
    values: { ...qntSeriesI18n.en.values, Yes: 'Evet', No: 'Hayır', 'Desk clamp': 'Masa kelepçesi', 'Monitor clip': 'Monitör klipsi', 'Table lamp': 'Masa lambası' }
  };

  const qntTask4I18n = {
    en: {
      supportHub: 'Visit Support Hub',
      resetFilters: 'Reset filters',
      contactSupport: 'Contact support',
      viewProduct: 'View product',
      viewSupportHub: 'View in Support Hub'
    },
    de: {
      supportHub: 'Support Hub besuchen',
      resetFilters: 'Filter zurücksetzen',
      contactSupport: 'Support kontaktieren',
      viewProduct: 'Produkt ansehen',
      viewSupportHub: 'Im Support Hub ansehen'
    },
    zh: {
      supportHub: '访问支持中心',
      resetFilters: '重置筛选',
      contactSupport: '联系支持',
      viewProduct: '查看产品',
      viewSupportHub: '在支持中心查看'
    },
    ja: {
      supportHub: 'サポートハブを見る',
      resetFilters: 'フィルターをリセット',
      contactSupport: 'サポートに連絡',
      viewProduct: '製品を見る',
      viewSupportHub: 'サポートハブで見る'
    },
    es: {
      supportHub: 'Visitar el centro de ayuda',
      resetFilters: 'Restablecer filtros',
      contactSupport: 'Contactar con soporte',
      viewProduct: 'Ver producto',
      viewSupportHub: 'Ver en el centro de ayuda'
    },
    fr: {
      supportHub: 'Visiter le centre d’assistance',
      resetFilters: 'Réinitialiser les filtres',
      contactSupport: 'Contacter l’assistance',
      viewProduct: 'Voir le produit',
      viewSupportHub: 'Voir dans le centre d’assistance'
    },
    it: {
      supportHub: 'Visita il centro assistenza',
      resetFilters: 'Reimposta filtri',
      contactSupport: 'Contatta l’assistenza',
      viewProduct: 'Vedi prodotto',
      viewSupportHub: 'Vedi nel centro assistenza'
    },
    pt: {
      supportHub: 'Visitar a Central de Suporte',
      resetFilters: 'Redefinir filtros',
      contactSupport: 'Entrar em contato com o suporte',
      viewProduct: 'Ver produto',
      viewSupportHub: 'Ver na Central de Suporte'
    },
    ar: {
      supportHub: 'زيارة مركز الدعم',
      resetFilters: 'إعادة ضبط عوامل التصفية',
      contactSupport: 'التواصل مع الدعم',
      viewProduct: 'عرض المنتج',
      viewSupportHub: 'العرض في مركز الدعم'
    },
    nl: {
      supportHub: 'Supporthub bezoeken',
      resetFilters: 'Filters resetten',
      contactSupport: 'Contact opnemen met support',
      viewProduct: 'Product bekijken',
      viewSupportHub: 'Bekijken in supporthub'
    },
    sv: {
      supportHub: 'Besök supporthubben',
      resetFilters: 'Återställ filter',
      contactSupport: 'Kontakta support',
      viewProduct: 'Visa produkt',
      viewSupportHub: 'Visa i supporthubben'
    },
    pl: {
      supportHub: 'Odwiedź centrum pomocy',
      resetFilters: 'Resetuj filtry',
      contactSupport: 'Skontaktuj się z pomocą',
      viewProduct: 'Zobacz produkt',
      viewSupportHub: 'Zobacz w centrum pomocy'
    },
    tr: {
      supportHub: 'Destek merkezini ziyaret edin',
      resetFilters: 'Filtreleri sıfırla',
      contactSupport: 'Destekle iletişime geç',
      viewProduct: 'Ürünü görüntüle',
      viewSupportHub: 'Destek merkezinde görüntüle'
    }
  };

  function qntMergeSeriesLocale(base, localized = {}) {
    const mergedCards = Object.fromEntries(
      Object.entries(base.cards).map(([key, value]) => [
        key,
        { ...value, ...(localized.cards?.[key] || {}) }
      ])
    );
    const mergedOptions = Object.fromEntries(
      Object.entries(base.options).map(([key, value]) => [
        key,
        { ...value, ...(localized.options?.[key] || {}) }
      ])
    );
    return {
      ...base,
      ...localized,
      columns: { ...base.columns, ...(localized.columns || {}) },
      series: { ...base.series, ...(localized.series || {}) },
      cards: mergedCards,
      options: mergedOptions,
      values: { ...base.values, ...(localized.values || {}) }
    };
  }

  Object.keys(qntSeriesI18n).forEach((lang) => {
    qntSeriesI18n[lang] = {
      ...qntMergeSeriesLocale(qntSeriesI18n.en, qntSeriesI18n[lang]),
      ...(qntTask4I18n[lang] || qntTask4I18n.en)
    };
  });

  const qntFinderProfiles = {
    focus: {
      series: 'focus',
      title: 'Focus Series',
      copy: 'Choose Focus Series for clean front light during long reading, typing, and screen-heavy work.',
      badges: [],
      picks: [
        'Focus 40 cm Black for compact desks',
        'Focus Dual-Control 41 cm Grey or White for flat monitors',
        'Focus Radar 52 cm Grey for wider work setups'
      ]
    },
    glow: {
      series: 'glow',
      title: 'Glow Series',
      copy: 'Choose Glow Series when you want front light with a softer back glow for calls, home office, or evening work.',
      badges: [],
      picks: [
        'Glow 41 cm Grey, White, or Pink for everyday desks',
        'Glow 51 cm Grey for larger screens',
        'Curved Glow 66 cm Black for ultrawide setups'
      ]
    },
    videoCalls: {
      series: 'glow',
      title: 'Glow Series',
      copy: 'For video calls, check camera-friendly models.',
      badges: [],
      picks: [
        'Glow 41 cm Grey, White, or Pink for webcam-friendly daily calls',
        'Glow 51 cm Grey for larger screens and video meetings',
        'Curved Glow 66 cm Black for ultrawide conferencing setups'
      ]
    },
    videoDual: {
      series: 'glow',
      title: 'Glow Series',
      copy: 'For dual-monitor video calls, check camera-friendly models with Multi light control.',
      badges: ['Multi light control'],
      picks: [
        'Glow 51 cm Grey for camera-friendly dual-screen meetings',
        'Curved Glow 66 cm Black for ultrawide or paired displays',
        'Glow models with Multi light control when both screens need balanced light'
      ]
    },
    im: {
      series: 'im',
      title: 'IM Series',
      copy: 'Choose IM Series when your desk needs eye-care front light plus RGB backlight for gaming, streaming, or movies.',
      badges: [],
      picks: [
        'IM 40 cm or 50 cm Black for gaming desks',
        'IM 51 cm Grey or Pink for larger setups',
        'Curved IM 66 cm or IM Music Sync 45 cm for immersive curved desks'
      ]
    },
    dual: {
      series: 'focus',
      title: 'Focus Series',
      copy: 'For a dual-monitor setup, start with Focus Series. Multi light control helps manage more than one light across a wider desk.',
      badges: ['Multi light control'],
      picks: [
        'Focus Dual-Control 41 cm Grey or White for paired monitor lights',
        'Focus Radar 52 cm Grey for wider dual-screen desks',
        'Glow or IM 51 cm models when dual monitors also need backlight'
      ]
    },
    studio: {
      series: 'studio',
      title: 'Studio Series',
      copy: 'Choose Studio Series when your desk needs broader task lighting, or when you prefer an eye-care lamp that clamps to the desk or sits on the tabletop instead of mounting on the monitor.',
      badges: [],
      picks: [
        '3-Stage Foldable Studio 82 cm Black for wide coverage',
        'Flex Desk Lamp Studio 78 cm Grey for desk-edge task light',
        'Studio works well when a monitor-mounted light is not enough'
      ]
    },
    piano: {
      series: 'studio',
      title: 'Quntis Piano Light',
      copy: 'For piano, choose the Quntis Piano Light Studio.',
      badges: ['Piano light'],
      picks: [
        'Quntis Piano Light Studio 60 cm (23.6 inch) Black'
      ],
      filters: {
        shape: 'piano-light',
        'monitor-type': 'non-monitor',
        'monitor-size': 'non-monitor'
      }
    },
    laptop: {
      series: 'focus',
      title: 'Quntis Laptop Light Bar',
      copy: 'For laptop setups, choose the Quntis Laptop Light Bar Focus 22.5 cm (8.9 inch).',
      badges: ['Laptop 11"–17"'],
      picks: [
        'Quntis Laptop Light Bar Focus 22.5 cm (8.9 inch)'
      ],
      filters: {
        'monitor-type': 'laptop',
        'monitor-size': 'laptop-11-17'
      }
    }
  };

  function qntResolveSeriesLanguage(section) {
    const serverLocale = section?.dataset.qntLocale;
    const documentLocale = document.documentElement.lang;
    return String(serverLocale || documentLocale || '').toLowerCase().split('-')[0];
  }

  function qntLocalizeTask4Nodes(section, copy) {
    const setText = (selector, value) => {
      section.querySelectorAll(selector).forEach((node) => {
        node.textContent = value;
      });
    };

    setText('.qnt-support-hub-link', copy.supportHub);
    setText('[data-comparison-reset]', copy.resetFilters);
    setText('[data-comparison-contact]', copy.contactSupport);
    setText('.qnt-product-hover', copy.viewProduct);

    section.querySelectorAll('[data-primary-product-cta]').forEach((node) => {
      const isSupportFallback = node.dataset.ctaKind === 'support';
      const label = isSupportFallback ? copy.viewSupportHub : copy.viewProduct;
      const productName = node.closest?.('[data-product-row]')
        ?.querySelector('.qnt-product-copy strong')?.textContent.trim();
      node.textContent = label;
      if (productName) node.setAttribute('aria-label', `${label}: ${productName}`);
    });

    section.querySelectorAll('[data-product-row]').forEach((row) => {
      const seriesLabel = row.querySelector('.qnt-mobile-product-series');
      if (seriesLabel) {
        seriesLabel.textContent = copy.series[row.dataset.series] || seriesLabel.textContent;
      }
    });
  }

  function qntInitSeriesSections() {
    document.querySelectorAll('.qnt-series-section').forEach((section) => {
    if (section.dataset.qntFinderInitialized === 'true') return;
    section.dataset.qntFinderInitialized = 'true';
    const lang = qntResolveSeriesLanguage(section);
    const copy = qntSeriesI18n[lang] || qntSeriesI18n.en;
    section.dataset.qntLang = lang;
    section.classList.toggle('is-rtl', lang === 'ar');
    section.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');

    const seriesColors = {
      all: section.style.getPropertyValue('--qnt-focus'),
      focus: section.style.getPropertyValue('--qnt-focus'),
      glow: section.style.getPropertyValue('--qnt-glow'),
      im: section.style.getPropertyValue('--qnt-im'),
      studio: section.style.getPropertyValue('--qnt-studio')
    };
    const rows = [...section.querySelectorAll('[data-product-row]')];
    const rowBySku = new Map(rows.map((row) => [row.dataset.sku, row]));
    const finderProducts = rows.map((row) => ({
      sku: row.dataset.sku,
      globalModelNumber: row.dataset.modelNumber,
      variantCode: row.dataset.variantCode,
      series: row.dataset.series,
      name: getProductName(row),
      productUrl: getProductLink(row),
      recommendable: row.dataset.recommendable !== 'false',
      filters: {
        color: row.dataset.color,
        shape: row.dataset.shape,
        monitorType: row.dataset.monitorType,
        monitorSize: row.dataset.monitorSize
      },
      specs: {
        monitorType: row.dataset.monitorType,
        multiLightPairing: row.dataset.multiLightPairing === 'true',
        webcamFriendly: row.dataset.webcamFriendly === 'true',
        smallDesk: row.dataset.smallDesk === 'true',
        curvedMonitor: row.dataset.curvedMonitor === 'true',
        autoDimming: row.dataset.autoDimming === 'true'
      }
    }));
    const filters = [...section.querySelectorAll('[data-filter]')];
    const seriesSelect = section.querySelector('[data-series-filter-select]');
    const shopFilterButtons = [...section.querySelectorAll('[data-finder-apply-filter]')];
    const toggles = [...section.querySelectorAll('[data-column-toggle]')];
    const empty = section.querySelector('.qnt-empty-state');
    const resultCount = section.querySelector('[data-result-count]');
    const detailControls = section.querySelector('.qnt-detail-controls');
    const detailCount = section.querySelector('[data-detail-count]');
    const shopMatchesList = section.querySelector('[data-shop-match-list]');
    const shopMatchToggle = section.querySelector('[data-shop-match-toggle]');
    const shopMatchCollapseLimit = 7;
    let activeSeries = 'all';
    let activeFinderSeries = 'focus';
    let activeFinderFilters = {};
    let shopMatchesExpanded = false;

    const finderAnalyticsFields = Object.freeze([
      "page_version",
      "variant_code",
      "model_number",
      "locale",
      "source_section",
      "result_count",
      "query_type",
      "query_length",
      "market"
    ]);
    const finderAnalyticsEvents = new Set([
      "finder_view",
      "finder_answer",
      "finder_complete",
      "browse_filter_change",
      "comparison_filter_change",
      "filter_no_results",
      "filter_reset",
      "product_click",
      "support_hub_click"
    ]);
    const finderAnalyticsSources = new Set([
      "light_finder",
      "quick_finder",
      "browse_by_need",
      "comparison",
      "support_hub",
      "comparison_empty",
      "comparison_toolbar",
      "page_footer",
      "page_header",
      "product_manual",
      "finder_result",
      "browse_results"
    ]);
    const finderAnalyticsQueryTypes = new Set([
      "filter",
      "guided_answers",
      "purpose",
      "setup",
      "light",
      "need_filter",
      "series",
      "backlight",
      "color",
      "control",
      "monitor-size",
      "monitor-thickness",
      "monitor-type",
      "shape",
      "comparison_filters",
      "support_fallback",
      "product",
      "manuals",
      "general",
      "initial"
    ]);
    const finderVariantPattern = /^(?:F(?:23BK|40BK|41GY1?|45BK|51BK|52BK|DC41(?:GY|WT))|FR52GY|G(?:41(?:GY|PK|WT)|42GY|51GY|66BK)|I(?:40BK|50BK|51(?:GY|PK)|66BK|MS45BK)|S(?:60BK|78GY|82BK))$/;
    const finderModelPattern = /^(?:LI-HY-02(?:01-(?:BK|GY)|05-BK|06-(?:BK|GY)|08-(?:BK|GY)|09-(?:BK|GY)|10-(?:BK|WT)|11-BK|12-(?:BK|GY|PK)|13-(?:BK|GY)|14-(?:BK|GY|PK|WT))|PA005S2|PHX002|HT8885|YS-TL23064)$/;
    const finderLocalePattern = /^(?:en|de|es|ja|fr|it|pt|ar|nl|sv|pl|tr|zh)(?:-(?:[A-Z]{2}|[0-9]{3}))?$/;

    function publishInteraction(name, data = {}) {
      try {
        if (!finderAnalyticsEvents.has(name) || !data || typeof data !== "object" || Array.isArray(data)) return;
        const aggregate = { page_version: "2026-07-24" };
        const optional = [
          ["variantCode", "variant_code", (value) => typeof value === "string" && value.length <= 8 && finderVariantPattern.test(value) ? value : null],
          ["modelNumber", "model_number", (value) => typeof value === "string" && value.length <= 16 && finderModelPattern.test(value) ? value : null],
          ["sourceSection", "source_section", (value) => typeof value === "string" && finderAnalyticsSources.has(value) ? value : null],
          ["resultCount", "result_count", (value) => Number.isSafeInteger(value) && value >= 0 && value <= 25 ? value : null],
          ["queryType", "query_type", (value) => typeof value === "string" && finderAnalyticsQueryTypes.has(value) ? value : null],
          ["queryLength", "query_length", (value) => Number.isSafeInteger(value) && value >= 0 && value <= 256 ? value : null]
        ];
        for (const [inputField, outputField, normalize] of optional) {
          if (!Object.prototype.hasOwnProperty.call(data, inputField)) continue;
          const rawValue = data[inputField];
          if (rawValue === "" || rawValue === null || rawValue === undefined) continue;
          const value = normalize(rawValue);
          if (value === null) return;
          aggregate[outputField] = value;
        }
        const rawLocale = section.dataset.qntLocale || document.documentElement.lang;
        if (typeof rawLocale === "string" && rawLocale.trim()) {
          const [base, region, extra] = rawLocale.trim().replace(/_/g, "-").split("-");
          if (!extra) {
            const locale = region
              ? `${base.toLowerCase()}-${/^[0-9]{3}$/.test(region) ? region : region.toUpperCase()}`
              : base.toLowerCase();
            if (locale.length <= 8 && finderLocalePattern.test(locale)) aggregate.locale = locale;
          }
        }
        const rawMarket = window.Shopify?.country;
        if (typeof rawMarket === "string" && /^[A-Za-z]{2}$/.test(rawMarket.trim())) {
          aggregate.market = rawMarket.trim().toUpperCase();
        }
        const payload = { event_name: name };
        finderAnalyticsFields.forEach((field) => {
          if (Object.prototype.hasOwnProperty.call(aggregate, field)) payload[field] = aggregate[field];
        });
        window.Shopify?.analytics?.publish?.("quntis_light_finder:interaction", payload);
      } catch (_error) {
        // Analytics must never block Finder interactions.
      }
    }

    function selectedFilterCount() {
      const comparisonFilters = filters.filter((filter) => filter.value !== 'all').length;
      return comparisonFilters + (activeSeries === 'all' ? 0 : 1);
    }

    function localizeStaticCopy() {
      qntLocalizeTask4Nodes(section, copy);
      const header = section.querySelector('.qnt-series-header');
      if (header) {
        header.querySelector('.qnt-eyebrow').textContent = copy.eyebrow;
        header.querySelector('h1').textContent = copy.title;
        header.querySelector('.qnt-header-intro').textContent = copy.intro;
      }
      const compareHeader = section.querySelector('.qnt-compare-header');
      if (compareHeader) {
        compareHeader.querySelector('.qnt-eyebrow').textContent = copy.comparisonEyebrow;
        compareHeader.querySelector('h2').textContent = copy.comparisonTitle;
        const compareIntro = compareHeader.querySelector('p:last-child:not(.qnt-eyebrow)');
        if (compareIntro && copy.comparisonIntro) compareIntro.textContent = copy.comparisonIntro;
      }
      section.querySelector('.qnt-series-grid')?.setAttribute('aria-label', copy.eyebrow);
      section.querySelector('.qnt-detail-controls')?.setAttribute('aria-label', copy.showDetails);
      const emptyCopy = empty?.querySelector('p');
      if (emptyCopy) emptyCopy.textContent = copy.noResults;

      Object.entries(copy.cards).forEach(([key, item]) => {
        const card = section.querySelector(`.qnt-series-card--${key}`);
        if (!card) return;
        card.querySelector('.qnt-card-copy strong').textContent = item.label;
        card.querySelector('.qnt-card-copy span').textContent = item.short;
        card.querySelector('.qnt-card-back span').textContent = item.detail;
        const image = card.querySelector('.qnt-line-image');
        if (image && image.hasAttribute('alt')) image.setAttribute('alt', item.label);
      });

      if (seriesSelect) {
        const seriesLabel = seriesSelect.closest('label')?.querySelector('span');
        if (seriesLabel) seriesLabel.textContent = copy.seriesFilter;
        [...seriesSelect.options].forEach((option) => {
          option.textContent = option.value === 'all' ? copy.all : (copy.series[option.value] || option.textContent);
        });
      }

      const optionGroups = {
        color: 'color',
        shape: 'shape',
        'monitor-type': 'monitorType',
        'monitor-size': 'monitorSize',
        'monitor-thickness': 'monitorThickness',
        backlight: 'backlight',
        control: 'control'
      };
      section.querySelectorAll('[data-filter]').forEach((select) => {
        const column = select.dataset.filter;
        const label = select.closest('label')?.querySelector('span');
        if (label) label.textContent = copy.columns[column] || label.textContent;
        const optionGroup = copy.options[optionGroups[column]] || qntSeriesI18n.en.options[optionGroups[column]];
        [...select.options].forEach((option) => {
          option.textContent = optionGroup[option.value] || option.textContent;
        });
      });

      const detailHeading = section.querySelector('.qnt-detail-summary-text');
      if (detailHeading) detailHeading.textContent = copy.showDetails;
      const allAction = section.querySelector('[data-detail-action="all"]');
      const noneAction = section.querySelector('[data-detail-action="none"]');
      if (allAction) allAction.textContent = copy.all;
      if (noneAction) noneAction.textContent = copy.none;
      toggles.forEach((toggle) => {
        const label = toggle.closest('label');
        const translated = copy.columns[toggle.dataset.columnToggle];
        if (label && translated) {
          [...label.childNodes].forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
          });
          label.append(` ${translated}`);
        }
      });

      const productHeader = section.querySelector('thead .qnt-product-col');
      if (productHeader) productHeader.textContent = copy.columns.product;
      section.querySelectorAll('thead [data-column]').forEach((cell) => {
        cell.textContent = copy.columns[cell.dataset.column] || cell.textContent;
      });
    }

    function translateCellValue(column, value, row) {
      const trimmed = value.trim();
      if (column === 'color') return copy.options.color[row.dataset.color] || trimmed;
      if (column === 'shape') return copy.options.shape[row.dataset.shape] || trimmed;
      if (column === 'monitor-type') return copy.options.monitorType[row.dataset.monitorType] || trimmed;
      if (column === 'monitor-size') return copy.options.monitorSize[row.dataset.monitorSize] || trimmed;
      if (column === 'monitor-thickness') return copy.options.monitorThickness[row.dataset.monitorThickness] || trimmed;
      if (column === 'backlight') return copy.options.backlight[row.dataset.backlight] || trimmed;
      if (column === 'control') return copy.options.control[row.dataset.control] || trimmed;
      return copy.values[trimmed] || trimmed;
    }

    function localizeRows() {
      rows.forEach((row) => {
        row.querySelectorAll('td[data-column]').forEach((cell) => {
          const original = cell.dataset.originalValue || cell.textContent.trim();
          cell.dataset.originalValue = original;
          cell.textContent = translateCellValue(cell.dataset.column, original, row);
        });
      });
    }

    section.querySelectorAll('.qnt-card-button').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
      });
    });

    function updateColumns() {
      let visibleColumns = 0;
      toggles.forEach((toggle) => {
        const column = toggle.dataset.columnToggle;
        const visible = toggle.checked;
        if (visible) visibleColumns += 1;
        toggle.closest('label').classList.toggle('is-on', visible);
        section.querySelectorAll(`[data-column="${column}"]`).forEach((cell) => {
          cell.classList.toggle('is-visible', visible);
        });
      });
      if (detailCount) {
        detailCount.textContent = visibleColumns === 1
          ? copy.detailCountOne
          : copy.detailCountMany.replace('{count}', visibleColumns);
      }
    }

    function getDatasetValue(row, key) {
      const datasetKey = key.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      return row.dataset[datasetKey];
    }

    function cellValue(row, column) {
      return row.querySelector(`[data-column="${column}"]`)?.textContent.trim() || '';
    }

    function getProductName(row) {
      return row?.querySelector('.qnt-product-copy strong')?.textContent.trim() || 'Quntis light';
    }

    function getProductLink(row) {
      return row?.dataset.productLink || row?.querySelector('.qnt-product-link')?.getAttribute('href') || '';
    }

    function isRecommendable(row) {
      return row?.dataset.recommendable !== 'false';
    }

    function appendProductPick(list, label, row) {
      const item = document.createElement('li');
      const href = getProductLink(row);
      const content = document.createElement(href ? 'a' : 'span');
      content.className = href ? 'qnt-product-pick-link' : 'qnt-product-pick-static';
      if (href) {
        content.href = href;
        content.target = '_blank';
        content.rel = 'noopener noreferrer';
        content.dataset.variantCode = row.dataset.variantCode || '';
        content.dataset.modelNumber = row.dataset.modelNumber || '';
        content.dataset.sourceSection = list.matches('[data-finder-result-picks]') ? 'finder_result' : 'browse_results';
      }

      const name = document.createElement('span');
      name.textContent = label;
      content.append(name);

      if (href) {
        const cta = document.createElement('span');
        cta.className = 'qnt-view-product';
        cta.textContent = copy.viewProduct || 'View product';
        content.append(cta);
      }

      item.append(content);
      list.append(item);
    }

    function updateShopMatches(visibleRows, visibleCount) {
      if (!shopMatchesList) return;
      shopMatchesList.innerHTML = '';
      const recommendedRows = visibleRows.filter(isRecommendable);
      if (recommendedRows.length === 0) {
        const note = document.createElement('li');
        note.className = 'qnt-shop-match-note';
        note.textContent = visibleCount === 0
          ? copy.noResults
          : (copy.noRecommendedResults || copy.noResults);
        shopMatchesList.append(note);
      } else {
        recommendedRows.forEach((row) => appendProductPick(shopMatchesList, getProductName(row), row));
      }
      updateShopMatchToggle(recommendedRows.length);
    }

    function updateShopMatchToggle(visibleCount) {
      const canToggle = visibleCount > shopMatchCollapseLimit;
      shopMatchesList?.classList.toggle('is-collapsed', canToggle && !shopMatchesExpanded);
      if (!shopMatchToggle) return;
      shopMatchToggle.hidden = !canToggle;
      shopMatchToggle.classList.toggle('is-expanded', canToggle && shopMatchesExpanded);
      shopMatchToggle.setAttribute('aria-expanded', String(canToggle && shopMatchesExpanded));
      shopMatchToggle.setAttribute(
        'aria-label',
        canToggle && shopMatchesExpanded
          ? (copy.shopMatchesCollapse || 'Show fewer matching products')
          : (copy.shopMatchesExpand || 'Show all matching products')
      );
    }

    function updateRows(eventMeta = {}) {
      const filterValues = Object.fromEntries(filters.map((filter) => [filter.dataset.filter, filter.value]));
      let visibleCount = 0;
      const visibleRows = [];
      rows.forEach((row) => {
        const matchesSeries = activeSeries === 'all' || row.dataset.series === activeSeries;
        const matchesFilters = Object.entries(filterValues).every(([key, value]) => value === 'all' || getDatasetValue(row, key) === value);
        const visible = matchesSeries && matchesFilters;
        row.hidden = !visible;
        if (visible) {
          visibleCount += 1;
          visibleRows.push(row);
        }
      });
      if (empty) empty.hidden = visibleCount > 0;
      if (resultCount) {
        resultCount.textContent = visibleCount === 1 ? copy.resultCountOne : copy.resultCountMany.replace('{count}', visibleCount);
      }
      updateShopMatches(visibleRows, visibleCount);
      if (visibleCount === 0 && eventMeta.publishNoResults) {
        publishInteraction('filter_no_results', {
          sourceSection: eventMeta.sourceSection || 'comparison',
          resultCount: 0,
          queryType: eventMeta.queryType || 'filter',
          queryLength: selectedFilterCount()
        });
      }
      return visibleCount;
    }

    function setActiveSeriesFilter(seriesKey) {
      activeSeries = seriesKey || 'all';
      section.style.setProperty('--active-series-color', seriesColors[activeSeries] || seriesColors.focus);
      if (seriesSelect && seriesSelect.value !== activeSeries) seriesSelect.value = activeSeries;
      const visibleCount = updateRows();
      refreshShopByState();
      return visibleCount;
    }

    function resolveFinderSeries(state) {
      if (state.setup === 'laptop') return 'laptop';
      if (state.purpose === 'piano') return 'piano';
      if (state.purpose === 'calls' && state.setup === 'dual') return 'videoDual';
      if (state.setup === 'dual') return 'dual';
      if (state.purpose === 'calls') return 'videoCalls';
      if (state.purpose === 'gaming' || state.purpose === 'streaming' || state.light === 'rgb') return 'im';
      if (state.purpose === 'creative' || state.purpose === 'crafting' || state.setup === 'wide' || state.light === 'task') return 'studio';
      if (state.purpose === 'daily' || state.light === 'ambient') return 'glow';
      return 'focus';
    }

    function answersForProfile(profileKey) {
      const profileAnswers = {
        focus: { purpose: 'work' },
        glow: { light: 'ambient' },
        videoCalls: { purpose: 'calls' },
        videoDual: { purpose: 'calls', setup: 'dual' },
        im: { light: 'rgb' },
        dual: { purpose: 'work', setup: 'dual' },
        studio: { light: 'task' },
        piano: { purpose: 'piano' },
        laptop: { setup: 'laptop' }
      };
      return profileAnswers[profileKey] || profileAnswers.focus;
    }

    function setFinderResult(profileKey, answers) {
      const nextProfileKey = qntFinderProfiles[profileKey] ? profileKey : 'focus';
      const profile = qntFinderProfiles[nextProfileKey];
      const recommendations = QuntisFinderCore.recommend(
        answers || answersForProfile(nextProfileKey),
        finderProducts
      );
      const nextSeries = recommendations[0]?.series || profile.series || nextProfileKey;
      const displayProfile = nextSeries === (profile.series || nextProfileKey)
        ? profile
        : (qntFinderProfiles[nextSeries] || profile);
      activeFinderSeries = nextSeries;
      activeFinderFilters = profile.filters || {};
      section.style.setProperty('--active-series-color', seriesColors[nextSeries] || seriesColors.focus);
      const title = section.querySelector('[data-finder-result-title]');
      const copyNode = section.querySelector('[data-finder-result-copy]');
      const picksNode = section.querySelector('[data-finder-result-picks]');
      const badgesNode = section.querySelector('[data-finder-result-badges]');
      if (title) title.textContent = displayProfile.title;
      if (copyNode) copyNode.textContent = displayProfile.copy;
      if (badgesNode) {
        badgesNode.innerHTML = '';
        (displayProfile.badges || []).forEach((badge) => {
          const item = document.createElement('span');
          item.textContent = badge;
          badgesNode.append(item);
        });
      }
      if (picksNode) {
        picksNode.innerHTML = '';
        recommendations.slice(0, Math.max(1, displayProfile.picks?.length || 3)).forEach((product) => {
          const row = rowBySku.get(product.sku);
          if (row) appendProductPick(picksNode, getProductName(row), row);
        });
      }
      section.querySelector('.qnt-finder-quiz')?.setAttribute('hidden', '');
      section.querySelector('.qnt-finder-result')?.removeAttribute('hidden');
      const firstRow = recommendations[0] ? rowBySku.get(recommendations[0].sku) : null;
      publishInteraction('finder_complete', {
        variantCode: firstRow?.dataset.variantCode || '',
        modelNumber: firstRow?.dataset.modelNumber || '',
        sourceSection: 'quick_finder',
        resultCount: recommendations.length,
        queryType: 'guided_answers',
        queryLength: Object.values(answers || answersForProfile(nextProfileKey)).filter(Boolean).length
      });
    }

    function initFinder() {
      const finderStepOrder = ['purpose', 'setup', 'light'];
      const finderState = {
        purpose: '',
        setup: '',
        light: ''
      };
      let activeFinderStep = 0;

      function renderFinderStep() {
        const activeKey = finderStepOrder[activeFinderStep] || finderStepOrder[0];
        section.querySelectorAll('[data-finder-step]').forEach((step) => {
          const isActive = step.dataset.finderStep === activeKey;
          step.hidden = !isActive;
          step.classList.toggle('is-active', isActive);
        });
        section.querySelector('.qnt-finder-quiz')?.removeAttribute('hidden');
        section.querySelector('.qnt-finder-result')?.setAttribute('hidden', '');
      }

      function resetFinder() {
        finderState.purpose = '';
        finderState.setup = '';
        finderState.light = '';
        activeFinderStep = 0;
        section.querySelectorAll('[data-finder-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });
        renderFinderStep();
        publishInteraction('filter_reset', {
          sourceSection: 'quick_finder',
          queryType: 'guided_answers'
        });
      }

      section.querySelectorAll('[data-finder-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          const [key, value] = button.dataset.finderAnswer.split(':');
          finderState[key] = value;
          publishInteraction('finder_answer', {
            sourceSection: 'quick_finder',
            queryType: key,
            queryLength: Object.values(finderState).filter(Boolean).length
          });
          if (key === 'purpose') {
            finderState.setup = '';
            finderState.light = '';
            section.querySelectorAll('[data-finder-answer^="setup:"], [data-finder-answer^="light:"]').forEach((item) => {
              item.setAttribute('aria-pressed', 'false');
            });
          }
          if (key === 'setup') {
            finderState.light = '';
            section.querySelectorAll('[data-finder-answer^="light:"]').forEach((item) => {
              item.setAttribute('aria-pressed', 'false');
            });
          }
          section.querySelectorAll(`[data-finder-answer^="${key}:"]`).forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
          if (key === 'purpose' && value === 'piano') {
            setFinderResult('piano', finderState);
            return;
          }
          if (key === 'setup' && value === 'laptop') {
            setFinderResult('laptop', finderState);
            return;
          }
          const stepIndex = finderStepOrder.indexOf(key);
          if (stepIndex >= 0 && stepIndex < finderStepOrder.length - 1) {
            activeFinderStep = stepIndex + 1;
            renderFinderStep();
          } else {
            setFinderResult(resolveFinderSeries(finderState), finderState);
          }
        });
      });

      section.querySelector('[data-finder-reset]')?.addEventListener('click', resetFinder);

      section.querySelectorAll('[data-finder-apply-series]').forEach((button) => {
        button.addEventListener('click', () => {
          const seriesKey = button.dataset.finderApplySeries;
          setFinderResult(seriesKey);
          setActiveSeriesFilter(seriesKey);
          section.querySelector('.qnt-comparison')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      renderFinderStep();
    }

    function parseShopFilterActions(value) {
      return (value || '').split('|').map((part) => {
        const [key, nextValue] = part.split(':');
        return { key, value: nextValue };
      }).filter((item) => item.key && item.value);
    }

    function getFilterValue(filterKey) {
      if (filterKey === 'series') return activeSeries;
      return filters.find((filter) => filter.dataset.filter === filterKey)?.value || 'all';
    }

    function setFilterValue(filterKey, value) {
      if (filterKey === 'series') {
        setActiveSeriesFilter(value);
        if (qntFinderProfiles[value]) setFinderResult(value);
        return;
      }
      const filter = filters.find((item) => item.dataset.filter === filterKey);
      if (filter) filter.value = value;
    }

    function refreshShopByState() {
      shopFilterButtons.forEach((button) => {
        const actions = parseShopFilterActions(button.dataset.finderApplyFilter);
        const isActive = actions.length > 0 && actions.every((action) => getFilterValue(action.key) === action.value);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    shopFilterButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => {
        shopMatchesExpanded = false;
        parseShopFilterActions(button.dataset.finderApplyFilter).forEach((action) => {
          setFilterValue(action.key, action.value);
        });
        const visibleCount = updateRows({
          publishNoResults: true,
          sourceSection: 'browse_by_need',
          queryType: 'need_filter'
        });
        refreshShopByState();
        publishInteraction('browse_filter_change', {
          sourceSection: 'browse_by_need',
          resultCount: visibleCount,
          queryType: 'need_filter',
          queryLength: selectedFilterCount()
        });
      });
    });

    seriesSelect?.addEventListener('change', () => {
      shopMatchesExpanded = false;
      const visibleCount = setActiveSeriesFilter(seriesSelect.value);
      publishInteraction('comparison_filter_change', {
        sourceSection: 'comparison',
        resultCount: visibleCount,
        queryType: 'series',
        queryLength: selectedFilterCount()
      });
      if (visibleCount === 0) {
        publishInteraction('filter_no_results', {
          sourceSection: 'comparison',
          queryType: 'series',
          queryLength: selectedFilterCount()
        });
      }
      if (qntFinderProfiles[seriesSelect.value]) setFinderResult(seriesSelect.value);
    });

    filters.forEach((filter) => filter.addEventListener('change', () => {
      shopMatchesExpanded = false;
      const visibleCount = updateRows({
        publishNoResults: true,
        sourceSection: 'comparison',
        queryType: filter.dataset.filter
      });
      refreshShopByState();
      publishInteraction('comparison_filter_change', {
        sourceSection: 'comparison',
        resultCount: visibleCount,
        queryType: filter.dataset.filter,
        queryLength: selectedFilterCount()
      });
    }));
    section.querySelectorAll('[data-comparison-reset]').forEach((button) => {
      button.addEventListener('click', () => {
        activeSeries = 'all';
        if (seriesSelect) seriesSelect.value = 'all';
        filters.forEach((filter) => {
          filter.value = 'all';
        });
        shopMatchesExpanded = false;
        const visibleCount = updateRows();
        refreshShopByState();
        publishInteraction('filter_reset', {
          sourceSection: 'comparison',
          resultCount: visibleCount,
          queryType: 'comparison_filters'
        });
      });
    });
    section.addEventListener('click', (event) => {
      const productLink = event.target.closest('[data-primary-product-cta], .qnt-product-link, .qnt-product-pick-link');
      if (productLink) {
        const row = productLink.closest('[data-product-row]');
        const href = productLink.getAttribute('href') || '';
        const interactionData = {
          variantCode: row?.dataset.variantCode || productLink.dataset.variantCode || '',
          modelNumber: row?.dataset.modelNumber || productLink.dataset.modelNumber || '',
          sourceSection: productLink.dataset.sourceSection || 'comparison',
          resultCount: 1,
          queryType: href.includes('/pages/quntis-support-hub') ? 'support_fallback' : 'product'
        };
        publishInteraction('product_click', interactionData);
        if (href.includes('/pages/quntis-support-hub')) {
          publishInteraction('support_hub_click', interactionData);
        }
      }

      const supportLink = event.target.closest('[data-support-hub-link]');
      if (supportLink) {
        publishInteraction('support_hub_click', {
          sourceSection: supportLink.dataset.sourceSection || 'support_hub',
          resultCount: 1,
          queryType: supportLink.getAttribute('href')?.includes('sku=') ? 'manuals' : 'general'
        });
      }
    });
    shopMatchToggle?.addEventListener('click', () => {
      shopMatchesExpanded = !shopMatchesExpanded;
      updateRows();
    });
    toggles.forEach((toggle) => toggle.addEventListener('change', updateColumns));
    document.addEventListener('click', (event) => {
      if (detailControls?.open && !detailControls.contains(event.target)) {
        detailControls.open = false;
      }
    });
    section.querySelectorAll('[data-detail-action]').forEach((button) => {
      button.addEventListener('click', () => {
        const checked = button.dataset.detailAction === 'all';
        toggles.forEach((toggle) => {
          toggle.checked = checked;
        });
        updateColumns();
      });
    });

    localizeStaticCopy();
    localizeRows();
    initFinder();
    updateColumns();
    updateRows();
    refreshShopByState();
    publishInteraction('finder_view', {
      sourceSection: 'light_finder',
      resultCount: rows.length,
      queryType: 'initial'
    });
  });
  }

  function qntInitSeriesWhenCoreReady() {
    if (!window.QuntisFinderCore) return false;
    qntInitSeriesSections();
    return true;
  }

  if (!qntInitSeriesWhenCoreReady()) {
    window.addEventListener('quntis-finder-core:ready', qntInitSeriesWhenCoreReady, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
